// 企业服务
<template>
    <div class="enterprise">
        <div class="one1">
            <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back1.png" alt="">
            <div class="one1_content">
                <div class="title_name title_name_one">你不是没有我们不行</div>
                <div class="title_name title_name_two">而是因为有了我们您会更好</div>
                <ul class="title_list">
                    <li>数字化企业管理</li>
                    <li>在线金融赋能</li>
                    <li>大数据决策支持</li>
                    <li>一站式供应链服务</li>
                    <li>技术赋能，助您的企业走过下一个十年</li>
                </ul>
            </div>
        </div>
        <div class="content one2">
            <div class="homeTitle">
                <div class="name">主要产品</div>
            </div>
            <div class="explain">MAIN PRODUCTS</div>
            <div class="titmeName">
                <div class="title">木材系统化管理、协同解决方案</div>
                <div class="explainTitle">全产业链全场景SaaS产品，助力企业数字化经营</div>
            </div>
            <div class="homeContent">
                <div class="homeContent_one2">
                    <div class="item wow animate__animated animate__bounceInRight" :data-wow-delay ="item.time+'s'" v-for="(item,index) in one2List"  v-bind:key="index">
                        <div class="item_content">
                            <i class="icon iconfont" :class="item.icon"></i>
                            <div class="explain">了解更多</div>
                            <div class="modification"></div>
                        </div>
                        <div class="name">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content one3">
            <div class="homeTitle">
                <div class="name">企业合作</div>
            </div>
            <div class="explain">COOPERATIVE ENTERPRISE</div>

            <div class="homeContent enterpriseContent homeContent_one3">
                <div class="content">
                    <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back2.png" alt="">
                    <div class="content_item">
                        <div class="item wow animate__animated animate__bounceInRight" data-wow-duration ="0.8s" data-wow-delay ="0.4s" v-for="(item,index) in one3_list" :key="index">
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content one4">
            <div class="homeTitle">
                <div class="name">数据&安全</div>
            </div>
            <div class="explain">DATA & SECURITY</div>

            <div class="homeContent enterpriseContent homeContent_one4">
                <div class="content">
                    <div class="item wow animate__animated animate__fadeInRightBig" :data-wow-delay="item.time +'s'" v-for="(item,index) in one4Data" :key="index">
                        <i class="icon iconfont" :class="item.icon"></i>
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content one5">
            <div class="homeTitle">
                <div class="name">服务&支持</div>
            </div>
            <div class="explain">SERVICE & SUPPORT</div>
            <div class="homeContent enterpriseContent homeContent_one5">
                <div class="item wow animate__animated animate__fadeInUpBig"  :data-wow-delay ="item.time+'s'" v-for="(item,index) in one5Data" :key="index">
                    <div class="left">
                        <p class="name">{{item.name}}</p>
                        <div class="explain">{{item.explain}}</div>
                    </div>
                    <div class="right">
                        <a class="aHref">
                            <img class="icon" :src="item.icon" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {
        msg: String
    },
    data(){
        return{
            one2List:[
                {
                    name:'松木ERP系统（德木云）',
                    icon:'iconerp',
                    time:0.2,
                },
                {
                    name:'木材仓储系统（德木云仓）',
                    icon:'iconyuncang',
                    time:0.4,
                },
                {
                    name:'在线金融系统（德木金融）',
                    icon:'iconjinrong',
                    time:0.6,
                },
                {
                    name:'大数据系统（德木云链）',
                    icon:'icondashuju',
                    time:0.8,
                },
                {
                    name:'硬木ERP系统（谱木云）',
                    icon:'iconzu1565',
                    time:1.0,
                },
            ],
            one3_list:[
                {
                    time:0.2,
                    img:require('@/assets/icon/company/1.png'),
                },{
                    time:0.4,
                    img:require('@/assets/icon/company/2.png'),
                },{
                    time:0.6,
                    img:require('@/assets/icon/company/3.png'),
                },{
                    time:0.8,
                    img:require('@/assets/icon/company/4.png'),
                },{
                    time:1.0,
                    img:require('@/assets/icon/company/5.png'),
                },{
                    time:1.2,
                    img:require('@/assets/icon/company/6.png'),
                },{
                    time:1.4,
                    img:require('@/assets/icon/company/7.png'),
                },{
                    time:1.6,
                    img:require('@/assets/icon/company/8.png'),
                },{
                    time:1.8,
                    img:require('@/assets/icon/company/9.png'),
                },{
                    time:2.0,
                    img:require('@/assets/icon/company/10.png'),
                },{
                    time:2.2,
                    img:require('@/assets/icon/company/11.png'),
                },{
                    time:2.4,
                    img:require('@/assets/icon/company/12.png'),
                },
            ],
            one4Data:[
                {
                    icon:'iconshujujiami',
                    name:'数据加密传输',
                    explain:'IP授权访问、阿里加密存储与备份保护数据安全',
                    time:0.2
                },
                {
                    icon:'iconyonghuanquan',
                    name:'用户信息安全',
                    explain:'整站Https化、防篡改、防监听有效保护DDoS攻击',
                    time:0.6
                },
                {
                    icon:'iconshengtaiwanshan',
                    name:'生态完善',
                    explain:'多系统数据互通、基于容器技术构建分布式开发',
                    time:1.0
                },
                {
                    icon:'iconjiaohuxingqiang',
                    name:'交互性强',
                    explain:'通过API/SDK方式调用第三方接口、系统消息实时交互',
                    time:1.4
                }
            ],
            one5Data:[
                {
                    name:'现场指导',
                    explain:'对初用系统的客户我们会安排工作人员上门现场 指导使用，PC端+移动端协同操作',
                    icon:require('../../../public/images/home_one4_1.jpg'),
                    time:0.2
                },
                {
                    name:'即时响应',
                    explain:'专业客服7*24小时服务，对用户的疑问 即时处理解决',
                    icon:require('../../../public/images/home_one4_2.jpg'),
                    time:0.4
                },
                {
                    name:'私人定制',
                    explain:'针对用户个性化需求私人定制，一对一开发',
                    icon:require('../../../public/images/home_one4_3.jpg'),
                    time:0.6
                }
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{
        
    }
}
</script>

<style scoped lang="scss">
    .enterprise{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
    .one1{
        width: 100%;height: 50rem;
        position: relative;
        .icon{
            height: 100%;width: 100%;
        }
        .one1_content{
            width: 104rem;height: 65%;
            padding: 2rem 8rem;
            background:rgba(0, 0, 0, 0.4);
            position: absolute;left: 50%;bottom: 0;transform: translateX(-50%); z-index: 2;
            border-top-left-radius: 0.6rem;
            border-top-right-radius: 0.6rem;
            color: #fff;
            .title_name{
                font-size: 3.5rem;
            }
            .title_name_one{text-indent: 30rem;}
            .title_name_two{text-align: right;}
            .title_list{font-size: 1.4rem;}
            .title_list li{margin-top: 1rem;}
        }
    }
    .enterprise .content{width: 100%;}
    .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
    .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
    .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
    .explain{text-align: center;color: #999999;}
    .homeContent{max-width: 120rem;margin: 0 auto;padding: 3rem 1rem;}
    .titmeName{text-align: center;margin: 1rem 0 0 0;}
    .titmeName .title{color: #333;font-weight: 600;font-size: 2.4rem;margin-bottom: 0.5rem;}
    .titmeName .explainTitle{color: #999999;font-weight: 600;font-size: 1.4rem;line-height: 2rem;}


    /* 按钮 style*/
    .operatButtom{display: flex;align-items: center;}
    .operatButtom .ontrial{display: flex;align-items: center;background: #3A6DF3;border-radius: 6px;color: white;padding: 0.5rem .8rem;}
    .ontrial:hover{cursor: pointer;}
    .operatButtom .consult{display: flex;align-items: center;background:#fff; border: 1px solid #3A6DF3; border-radius: 6px;color: #3A6DF3;padding: 0.5rem .8rem;margin-left: 1rem;}
    .consult:hover{cursor: pointer;}
    .enterpriseContent .left,.enterpriseContent .right{flex: 1;}

    .homeContent_one2{display: flex;flex-wrap: nowrap;justify-content: center;}
    .homeContent_one2 .item{width: 20%;margin-left: 2rem; display: flex;flex-direction: column; justify-content: center;align-items: center;}
    .homeContent_one2 .item:first-child{margin-left: 0;}
    .homeContent_one2 .item .item_content{border: 0.1rem solid #ddd;border-radius: 1.5rem;height: 22rem; padding: 0 6rem;display: flex;flex-direction: column; align-items: center;justify-content: center;}
    .homeContent_one2 .item .item_content:hover{box-shadow: 3px 3px 15px rgba(51, 51, 51, 0.5);cursor: pointer;background: #4D78E3;border-color: #4D78E3;}
    .homeContent_one2 .item .item_content:hover .explain,.homeContent_one2 .item .item_content:hover .modification{display: block;}
    .homeContent_one2 .item .item_content:hover .icon{color: #fff;}
    .homeContent_one2 .item .item_content .icon{font-size: 4rem;color: #4D78E3;}
    .homeContent_one2 .item .item_content .explain{margin-top: 2rem;color: #fff;display: none;}
    .homeContent_one2 .item .item_content .modification{background: #fff;width:4rem;height: 0.8rem;border-radius: 1rem;margin-top: 2rem;display: none;}
    .homeContent_one2 .item .name{line-height: 2rem;font-size: 1.4rem;margin-top: 2rem;}

    .homeContent_one3{display: flex;}
    .homeContent_one3 .content{
        overflow: hidden;
        width: 100%;
        height: 60rem;
        border-radius: 2rem;
        position: relative;
        .icon{height: 100%;width: 100%;vertical-align: middle;transition: all .6s;}
        .icon:hover{transform:scale(1.1);cursor: pointer;}
        .content_item{
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 2rem 2rem 0 0;
            .item{width: 27.5rem;height: 17.2rem;background: rgba(255, 255, 255, 0.6);margin: 0 0 2rem 2rem;border-radius: 0.6rem;display: flex;align-items: center;justify-content: center;
                >img{width: 17rem;}
            }
        }
    }

    .homeContent_one4{height: 28rem;width: 100%;border: 1px solid #ddd;margin-top: 3rem;background: #4D78E3;color: #fff;border-radius: 0.6rem;}
    .homeContent_one4 .content{display: flex;align-items: center;justify-content: space-between;
        height: 100%;
        .item{display: flex;height: 100%;align-items: center;flex-direction: column;justify-content: center;
            padding: 0 4rem;
            .icon{font-size: 6rem;}
            .name{margin: 3rem 0 2rem 0;font-size: 1.6rem;font-weight: 600;}
            .explain{color: #fff;font-size: 1.4rem;}
        }
    }

    .homeContent_one5{display: flex;}
    .homeContent_one5 .item{display: flex;flex: 1; flex-direction: column;justify-content: space-between; align-items: center;text-align: center;padding: 0 1rem;}
    .homeContent_one5 .item:first-child{padding-left: 0;}
    .homeContent_one5 .item:last-child{padding-right: 0;}
    .homeContent_one5 .item .left{height: 8rem;color: #333333;padding: 0 4rem;}
    .homeContent_one5 .item .left .name{font-size: 1.6rem;font-weight: 600;margin-bottom: 0.4rem;}
    .homeContent_one5 .item .left .explain{color: #333333;line-height: 2rem;}
    .homeContent_one5 .item .right{width: 100%;}
    .homeContent_one5 .item .aHref{width: 100%;position: relative;overflow: hidden;display: inline-block;border-radius: 0.8rem;}
    .homeContent_one5 .item .right .icon{max-width: 100%;vertical-align: middle;transition: all .6s;}
    .homeContent_one5 .item .right .icon:hover{transform:scale(1.1);cursor: pointer;}
</style>
